export default {"src":"/_next/static/media/logo-CCA-green.98069453.svg","height":120,"width":426,"blurWidth":0,"blurHeight":0};